import * as swcHelpers from '@swc/helpers';
import { DateUtils } from '@grandvisionhq/utils';
import { getExtraDataEvent, getStoreDetails, getAgeRangeLabel, getStoreDetailsWithoutCountry, getStoreDetailsWithStock } from './utils.js';

const rescheduleAppointmentScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '800',
                condition_of_appointment: 'reschedule',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: 'screen-for',
                section_of_the_element: '',
                text_of_the_element: 'reschedule',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const rescheduleAppointmentConfirmationScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '900',
                condition_of_appointment: 'reschedule',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: 'screen-for',
                section_of_the_element: '',
                text_of_the_element: 'reschedule-confirmation',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const cancelAppointmentScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '1000',
                condition_of_appointment: 'cancel',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: 'screen-for',
                section_of_the_element: '',
                text_of_the_element: 'cancel',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const cancelAppointmentConfirmationScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '1100',
                condition_of_appointment: 'cancel',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: 'screen-for',
                section_of_the_element: '',
                text_of_the_element: 'cancel-confirmation',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const bookAppointmentWhereStepScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '110',
                condition_of_appointment: 'new',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: '',
                section_of_the_element: '',
                text_of_the_element: 'where',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const bookAppointmentWhatStepScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '200',
                condition_of_appointment: 'new',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: '',
                section_of_the_element: '',
                text_of_the_element: 'what',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const bookAppointmentWhenStepScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '300',
                condition_of_appointment: 'new',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: '',
                section_of_the_element: '',
                text_of_the_element: 'when',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const bookAppointmentWhoStepScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '400',
                condition_of_appointment: 'new',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: '',
                section_of_the_element: '',
                text_of_the_element: 'who',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const getStepNumber = (steps, step)=>steps[step]
;
const isValidStepKey = (route, steps)=>route in steps
;
const bookAppointmentStepClickEvent = (input, steps, originStep, targetStep)=>{
    const originStepNumber = getStepNumber(steps, originStep);
    const targetStepNumber = getStepNumber(steps, targetStep);
    return {
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '420',
                condition_of_appointment: 'new',
                action_taken: 'change'
            },
            label: {
                clicked_element: 'main menu',
                text_of_the_element: `${originStepNumber} - ${targetStepNumber}`,
                extra: getExtraDataEvent(input)
            }
        }
    };
};
const bookAppointmentSelectedChoiceClickEvent = (input, steps, originStep, targetStep)=>{
    const originStepNumber = getStepNumber(steps, originStep);
    const targetStepNumber = getStepNumber(steps, targetStep);
    return {
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '421',
                condition_of_appointment: 'new',
                action_taken: 'change'
            },
            label: {
                clicked_element: 'side menu',
                text_of_the_element: `${originStepNumber} - ${targetStepNumber}`,
                extra: getExtraDataEvent(input)
            }
        }
    };
};
const bookAppointmentConfirmationScreenEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '500',
                condition_of_appointment: 'new',
                action_taken: 'pageview'
            },
            label: {
                clicked_element: '',
                section_of_the_element: '',
                text_of_the_element: 'appointment confirmation',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const bookAppointmentOnSurveyLinkClick = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '520',
                condition_of_appointment: 'new',
                action_taken: 'click'
            },
            label: {
                clicked_element: '',
                text_of_the_element: 'provide information - start survey',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const storeBookAppointmentClickEvent = ({ event , storeDetails ,  })=>({
        event,
        storeLocator: {
            action: {
                step: 'store locator details',
                interaction: 'book appointment click'
            },
            store: getStoreDetails(storeDetails)
        }
    })
;
const storeFastAppointmentClickEvent = ({ event , storeDetails , selectedDateTime , appointmentType ,  })=>({
        event,
        storeLocator: {
            action: {
                step: 'store locator details',
                interaction: 'book fast appointment click'
            },
            store: getStoreDetails(storeDetails),
            fastAppointment: {
                selectedDateTime: DateUtils.toLocalDateTimeTimeZone(selectedDateTime),
                appointmentType
            }
        }
    })
;
const storeChangeAppointmentTypeClickEvent = ({ event , storeDetails ,  })=>({
        event,
        storeLocator: {
            action: {
                step: 'store locator details',
                interaction: 'change appointment type click'
            },
            store: getStoreDetails(storeDetails)
        }
    })
;
const appointmentBookingPreferredTimeEvent = ({ condition_of_appointment , appointment , step_number , ageGroup , text_of_the_element , storeDetails , time ,  })=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number,
                condition_of_appointment,
                action_taken: 'click'
            },
            label: {
                clicked_element: '',
                text_of_the_element,
                extra: {
                    appointment: swcHelpers.objectSpread({}, appointment, {
                        age_range: getAgeRangeLabel(ageGroup)
                    }),
                    store: getStoreDetailsWithoutCountry(storeDetails),
                    time: {
                        startTime: time.startTime ? DateUtils.toLocalDateTimeTimeZone(time.startTime) : '',
                        endTime: time.endTime ? DateUtils.toLocalDateTimeTimeZone(time.endTime) : ''
                    }
                }
            }
        }
    })
;
const appointmentBookingAlternativeLocationEvent = ({ condition_of_appointment , appointment , ageGroup , text_of_the_element , storeDetails , time ,  })=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '397',
                condition_of_appointment,
                action_taken: 'click'
            },
            label: {
                clicked_element: '',
                text_of_the_element,
                extra: {
                    appointment: swcHelpers.objectSpread({}, appointment, {
                        age_range: getAgeRangeLabel(ageGroup)
                    }),
                    store: getStoreDetailsWithoutCountry(storeDetails),
                    time: {
                        startTime: time.startTime ? DateUtils.toLocalDateTimeTimeZone(time.startTime) : '',
                        endTime: time.endTime ? DateUtils.toLocalDateTimeTimeZone(time.endTime) : ''
                    }
                }
            }
        }
    })
;
const appointmentConditionMapStepNumberAddToCalendar = {
    new: '510',
    reschedule: '910'
};
const appointmentBookingAddToCalendarEvent = ({ condition_of_appointment , appointment , ageGroup , text_of_the_element , storeDetails ,  })=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: appointmentConditionMapStepNumberAddToCalendar[condition_of_appointment],
                condition_of_appointment,
                action_taken: 'click'
            },
            label: {
                clicked_element: '',
                text_of_the_element,
                extra: {
                    appointment: swcHelpers.objectSpread({}, appointment, {
                        age_range: getAgeRangeLabel(ageGroup)
                    }),
                    store: getStoreDetailsWithoutCountry(storeDetails),
                    time: {
                        // time is not applicable in this case
                        startTime: '',
                        endTime: ''
                    }
                }
            }
        }
    })
;
const timeSelectionErrorEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '460',
                condition_of_appointment: 'new',
                action_taken: 'error'
            },
            label: {
                clicked_element: '',
                text_of_the_element: 'error_time_selection',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const timeSelectionNewHourSameDayEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '461',
                condition_of_appointment: 'new',
                action_taken: 'click'
            },
            label: {
                clicked_element: '',
                text_of_the_element: 'available_time_click',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const timeSelectionNewHourOtherDayEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '462',
                condition_of_appointment: 'new',
                action_taken: 'click'
            },
            label: {
                clicked_element: '',
                text_of_the_element: 'select_another_day_click',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const timeSelectionOtherDayEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '463',
                condition_of_appointment: 'new',
                action_taken: 'click'
            },
            label: {
                clicked_element: '',
                text_of_the_element: 'select_another_day_click',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const viewStoresNearbyClickEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '397a',
                condition_of_appointment: 'new',
                action_taken: 'click'
            },
            label: {
                clicked_element: 'view stores nearby button',
                text_of_the_element: 'view stores nearby',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const chooseAnotherStoreClickEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '397b',
                condition_of_appointment: 'new',
                action_taken: 'click'
            },
            label: {
                clicked_element: 'choose another store button',
                text_of_the_element: 'choose another store',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const clickOnAlternativeLocationEvent = (input)=>{
    var ref, ref1, ref2;
    return {
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '397c',
                condition_of_appointment: 'new',
                action_taken: 'click'
            },
            label: {
                clicked_element: 'stores with availability for this date',
                text_of_the_element: `${input === null || input === void 0 ? void 0 : (ref = input.store) === null || ref === void 0 ? void 0 : ref.name} - ${(input === null || input === void 0 ? void 0 : (ref1 = input.store) === null || ref1 === void 0 ? void 0 : ref1.nextAvailableBookingDate) ? DateUtils.toLocalDateTimeTimeZone(input === null || input === void 0 ? void 0 : (ref2 = input.store) === null || ref2 === void 0 ? void 0 : ref2.nextAvailableBookingDate) : ''}`,
                extra: getExtraDataEvent(input)
            }
        }
    };
};
const aabFAQClickEvent = (input)=>({
        event: 'appointment-booking',
        specifications: {
            action: {
                step_number: '240',
                condition_of_appointment: 'new',
                action_taken: 'click'
            },
            label: {
                clicked_element: '',
                text_of_the_element: 'FAQ_click',
                extra: getExtraDataEvent(input)
            }
        }
    })
;
const aabPreferredStoreClickEvent = ({ store , itemType ,  })=>({
        event: itemType === 'map' ? 'preferred_store_map_click' : 'preferred_store_click',
        site_feature: 'store_locator',
        flow_name: 'AAB',
        store: getStoreDetailsWithStock(store)
    })
;

export { aabFAQClickEvent, aabPreferredStoreClickEvent, appointmentBookingAddToCalendarEvent, appointmentBookingAlternativeLocationEvent, appointmentBookingPreferredTimeEvent, appointmentConditionMapStepNumberAddToCalendar, bookAppointmentConfirmationScreenEvent, bookAppointmentOnSurveyLinkClick, bookAppointmentSelectedChoiceClickEvent, bookAppointmentStepClickEvent, bookAppointmentWhatStepScreenEvent, bookAppointmentWhenStepScreenEvent, bookAppointmentWhereStepScreenEvent, bookAppointmentWhoStepScreenEvent, cancelAppointmentConfirmationScreenEvent, cancelAppointmentScreenEvent, chooseAnotherStoreClickEvent, clickOnAlternativeLocationEvent, isValidStepKey, rescheduleAppointmentConfirmationScreenEvent, rescheduleAppointmentScreenEvent, storeBookAppointmentClickEvent, storeChangeAppointmentTypeClickEvent, storeFastAppointmentClickEvent, timeSelectionErrorEvent, timeSelectionNewHourOtherDayEvent, timeSelectionNewHourSameDayEvent, timeSelectionOtherDayEvent, viewStoresNearbyClickEvent };
//# sourceMappingURL=actions.js.map
